import React from 'react';
import { motion } from 'framer-motion';
import { 
  FaChartLine, 
  FaPercent, 
  FaBalanceScale, 
  FaShieldAlt 
} from 'react-icons/fa';

const PerformanceCard = ({ title, value, description, icon, delay }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay }}
      viewport={{ once: true }}
      className="bg-primary rounded-xl p-8 text-white shadow-custom hover:shadow-custom-lg transition-all duration-300 transform hover:-translate-y-2 group"
    >
      <div className="flex justify-between items-start mb-6">
        <div className="bg-white/10 p-4 rounded-full">
          {icon}
        </div>
        <div className="text-4xl font-heading font-bold text-secondary">
          {value}
        </div>
      </div>
      <h3 className="text-xl font-heading font-semibold mb-3">{title}</h3>
      <p className="text-gray-300 text-sm group-hover:text-white transition-colors">
        {description}
      </p>
    </motion.div>
  );
};

const PerformanceSection = () => {
  const performanceMetrics = [
    {
      icon: <FaChartLine className="w-6 h-6 text-secondary" />,
      title: "Annual Return",
      value: "14.2%",
      description: "Average annual return of our aggressive growth portfolio over the past 5 years."
    },
    {
      icon: <FaPercent className="w-6 h-6 text-secondary" />,
      title: "Outperformance",
      value: "8.4%",
      description: "Our flagship fund has outperformed the market benchmark by this percentage."
    },
    {
      icon: <FaBalanceScale className="w-6 h-6 text-secondary" />,
      title: "Risk-Adjusted Return",
      value: "1.8",
      description: "Sharpe ratio demonstrating our ability to balance risk and return effectively."
    },
    {
      icon: <FaShieldAlt className="w-6 h-6 text-secondary" />,
      title: "Capital Preservation",
      value: "97%",
      description: "Capital preservation rate during market downturns, showcasing our defensive strategy."
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-background">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-heading font-bold text-primary mb-6">Our Performance</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Segway Capital Management has consistently delivered market-beating returns while maintaining a disciplined approach to risk management.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {performanceMetrics.map((metric, index) => (
            <PerformanceCard
              key={index}
              icon={metric.icon}
              title={metric.title}
              value={metric.value}
              description={metric.description}
              delay={0.1 * index}
            />
          ))}
        </div>

        {/* <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          viewport={{ once: true }}
          className="mt-16 text-center"
        >
          <p className="text-sm text-gray-500 max-w-3xl mx-auto italic">
            Past performance is not necessarily indicative of future results. The performance data quoted represents past performance and current returns may be lower or higher. The investment return and principal value of an investment will fluctuate so that an investor's shares, when redeemed, may be worth more or less than the original cost.
          </p>
        </motion.div> */}
      </div>
    </section>
  );
};

export default PerformanceSection; 